import * as React from "react";

import * as cx from "classnames";
import * as i18next from "i18next";
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
// import * as Utils from '@Cyclope-Utils/index';

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { item, widthCart } = props;

  /**
   * @constant
   */
  /**
   * @description : le tableua relatif
   * à la position de l'incidents
   * @const
   * @name dataCar
   * @type { strin[]  }
   */
  const dataCar: string[] = [
    i18next.t("voie de gauche"),
    i18next.t("voie de droite"),
    i18next.t("parking"),
    i18next.t("bau"),
    i18next.t("trottoir"),
  ];

  // const widthCart= Math.ceil(Utils.fullWidthContent() * 0.324) + "px";
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name i18next
   * @name moment
   * @infos "https://reactjs.org"
   */

  return (
    <div
      className="Vcart-vcart animated fadeIn "
      style={{
        height: "100%",
        width: `${widthCart}px`,
        marginRight: "15px",
        marginBottom: "0",
      }}
    >
      <div className="cartIncidents">
        <div className={cx("headerInhibitions", { rightNow: true })}>
          <span>
            {" "}
            {item.camera && item.camera.code} | {item.origin}{" "}
            {item.laneId && "|"} {item.laneId && dataCar[Number(item.laneId)]}{" "}
          </span>
          <span> {i18next.t("en cours")}</span>
        </div>
        <div className="cartIncidentContent">
          <p> {i18next.t("incidents inhibes")}</p>
          <div className="cartIncidentContentInhibition">
            {item.incidentTypes &&
              item.incidentTypes
                .filter((elem: any) => elem.id !== 2)
                .map((Elem: any, index: number) => {
                  return (
                    <div
                      className="part-right left"
                      style={{ height: "unset", marginBottom: "2px" }}
                      key={index}
                    >
                      <span> {i18next.t(`${Elem.label}`)}</span>{" "}
                    </div>
                  );
                })}
          </div>
        </div>

        <div
          className="cartBottomContent"
          style={{ borderTop: "1px solid #f3f3f3" }}
        >
          <Link
            className="btnSecondary"
            style={{ padding: "8px 20px", width: "120px" }}
            to={{
              pathname:
                Paths.PathsNamesEnums.CAMERASETTINGID +
                `${item.camera && item.camera.id}`,
            }}
          >
            <span className="borderGradian">
              {" "}
              <span
                className="btnSecondary "
                style={{ backgroundColor: "white", overflow: "visible" }}
              >
                <span className="textGradianlarge">
                  {i18next.t("visualiser")}
                </span>
              </span>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

Component.defaultProps = {
  IncidentsType: [],
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  item?: any;
  onRemoveInhibition?: any;
  authorization?: any;
  widthCart?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/inhibition-camera/component.tsx